import { ARROW_PREFIX } from './utils/constant';
import { get } from '@services/http_services/http_services';
import Cookies from 'universal-cookie';
const cookies = new Cookies();
const client = cookies.get('client');
export const getMenu = ({ loginType }) =>
  get(`/${ARROW_PREFIX}/sidebar/${loginType === 'doctor' ? 'SmarterHealth' : client}`);
